/**
 * DOM Helpers Module
 *
 * Handles DOM manipulation and utilities
 */

/**
 * Add transition animation to the date navigation
 *
 * @param {Function} callback - Function to execute during transition
 */
export function animateTransition(callback) {
  const datesContainer = document.querySelector(
    '.wp-block-big-bite-stats-perform-fixtures__nav-dates',
  );
  const monthYearElement = document.querySelector(
    '.wp-block-big-bite-stats-perform-fixtures__nav-month-year',
  );

  if (datesContainer) {
    datesContainer.classList.add('transitioning');
  }

  if (monthYearElement) {
    monthYearElement.style.opacity = '0.3';
  }

  // Execute the callback after a short delay
  setTimeout(() => {
    callback();

    // Remove transition class after animation completes
    setTimeout(() => {
      if (datesContainer) {
        datesContainer.classList.remove('transitioning');
      }
      if (monthYearElement) {
        monthYearElement.style.opacity = '1';
      }
    }, 300);
  }, 150);
}

/**
 * Update competition dropdown with fresh data
 *
 * @param {Array} competitions - Array of competition objects
 */
export function updateCompetitionDropdown(competitions) {
  const selectElement = document.querySelector(
    '.wp-block-big-bite-stats-perform-fixtures__competition-select',
  );

  if (!selectElement || !competitions) {
    return;
  }

  // Store current selection
  const currentValue = selectElement.value;

  // Clear all existing options
  selectElement.innerHTML = '';

  // Add all competition options (including "All Competitions" from API)
  competitions.forEach((competition) => {
    const option = document.createElement('option');
    option.value = competition.id;
    option.textContent = competition.name;
    selectElement.appendChild(option);
  });

  // Restore selection if still valid
  if (currentValue && [...selectElement.options].some((opt) => opt.value === currentValue)) {
    selectElement.value = currentValue;
  }
}
